<template>
    <CompassMenu
        placement="top"
        trigger="click"
        custom-class="custom-menu-container-textalign"
        :disabled="disabled"
    >
        <CompassTooltip
            :content="$t.__(getExtensionOption(option).label)"
            placement="top"
            :delay="{ show: 0, hide: 1 }"
            :disabled="disabled"
        >
            <CompassIconButton
                :icon="getExtensionOption(option).icon"
                size="small"
                :disabled="disabled"
                :active="activeStyle(option)"
                show-dropdown
            />
        </CompassTooltip>
        <template slot="dropdown">
            <CompassTooltip
                v-for="(textAlign, indexTextAlign) in allTextAlign"
                :key="indexTextAlign"
                placement="right"
                :delay="{ show: 0, hide: 1 }"
                :disabled="disabled"
            >
                <template slot="content">
                    <span>{{ $t.__(getExtensionOption(textAlign).label) }}</span>
                    <span class="option-shortcuts">
                        {{ getExtensionOption(textAlign).shortcuts }}
                    </span>
                </template>
                <CompassIconButton
                    :icon="getExtensionOption(textAlign).icon"
                    size="small"
                    :disabled="disabled"
                    @click="getExtensionOption(textAlign).action()"
                />
            </CompassTooltip>
        </template>
    </CompassMenu>
</template>

<script>
import OptionsRichTextMixin from 'mixins/OptionsRichTextMixin';

export default {
    name: 'SizeRichText',
    mixins: [OptionsRichTextMixin],
    data() {
        return {
            allTextAlign: [
                'TextAlignLeft',
                'TextAlignCenter',
                'TextAlignRight',
                'TextAlignJustify',
            ],
        };
    },
};
</script>
